import { getFulfillmentStatus, getOrderStatus } from './FulfillmentStatus';
import { searchNestedProperties } from './safelyAccessNestedProperties';
export var setTrackingButtonVisibility = function (statusCode, fulfillmentType, fulfillmentGroup) {
    var orderStatus = getOrderStatus(statusCode);
    var fulfillmentMethod = getFulfillmentStatus(fulfillmentType);
    var shouldSkipTracking = (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isBackOrdered) &&
        (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isCanceled) &&
        (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isReturned);
    if (fulfillmentGroup === undefined)
        return false;
    if (fulfillmentMethod === null || fulfillmentMethod === void 0 ? void 0 : fulfillmentMethod.isFulfillmentSTHorBOSS) {
        if (shouldSkipTracking)
            return false;
        if (Object.keys(fulfillmentGroup !== null && fulfillmentGroup !== void 0 ? fulfillmentGroup : {}).filter(function (element) {
            return ['shippingAndHandling', 'shipments', 'shipment'].includes(element);
        }).length === 0)
            return false;
        return true;
    }
    if (fulfillmentMethod === null || fulfillmentMethod === void 0 ? void 0 : fulfillmentMethod.isMA) {
        if (searchNestedProperties(['shippingAndHandling', 'applianceDeliveries', 0, 'deliveryTrackerUrl'], fulfillmentGroup)) {
            return true;
        }
        return !(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isDelivered) && !(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isOrderCompleted);
    }
    if (fulfillmentMethod === null || fulfillmentMethod === void 0 ? void 0 : fulfillmentMethod.isFulfillmentBODFSorDFS) {
        return orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isShipped;
    }
    return ((orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isProcessing) ||
        (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isReadyForPickup) ||
        (orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isBODFSOnSchedule) ||
        (!shouldSkipTracking && !(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.isReturnStarted)));
};
export var isLessThan90DaysBetweenDates = function (date1, date2) {
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.floor(diff / (1000 * 60 * 60 * 24)) < 90;
};
